import ax from '@/utils/axios';
import store from '@/store';
import Keys from '@/store/keys';

import CryptoJS from 'crypto-js';

export const authLogin = (email: string, password: string) => {
    return new Promise( (res, rej) => {
        try {
             ax
                .post('login', {
                    email: email,
                    password: password
                })
                .then((response) => {
                    return res(response.data);
                })
                .catch((response) => {
                    return rej(response);
                });
        } catch (error) {
            return rej(error);
        }
    });
};

export const authStatus = () => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (res, rej) => {
        //const auth = localStorage.getItem('tkn');

        const y_token   = localStorage.getItem('x_token') ;
        const y_access  = localStorage.getItem('x_access');
        const y_keys    = localStorage.getItem('x_keys')  ;
        const y_public  = localStorage.getItem('x_public');

        const b_token   = y_token ? CryptoJS.AES.decrypt( y_token, Keys.state.public).toString(CryptoJS.enc.Utf8)   : "";
        const b_access  = y_access? CryptoJS.AES.decrypt( y_access, Keys.state.public).toString(CryptoJS.enc.Utf8)  : "";
        const b_keys    = y_keys  ? CryptoJS.AES.decrypt( y_keys, Keys.state.public).toString(CryptoJS.enc.Utf8)    : "";
        const b_public  = y_public? CryptoJS.AES.decrypt( y_public, Keys.state.public).toString(CryptoJS.enc.Utf8)  : "";

        const real_token= b_token + b_access + b_keys + b_public;
        
        if(real_token){
            try {
                await ax
                    .get('user/show')
                    .then((response) => {
                        if(response.data.status){
                            store.dispatch('user/setUser', response.data.data);
                            store.dispatch('ui/setLayoutSidebarMode', response.data.data.ui.layout_sidebar_mode);
                            store.dispatch('ui/onChangeDarkTheme', response.data.data.ui.is_dark);
                            return res(response.data);
                        }
                        return rej(response.data);
                    })
                    .catch((response) => {
                        return rej(response);
                    });
            } catch (error) {
                rej(error);
            }
        }
        return rej({
            status: false,
            message: 'token autentikasi tidak ditemukan',
            data: [],
            errors: []
        });
    });
};

export const authLogout = () => {
    return new Promise( (res , rej) => {
        try {
             ax
                .post('logout')
                .then((response) => {
                    localStorage.removeItem('x_token');
                    localStorage.removeItem('x_access');
                    localStorage.removeItem('x_keys');
                    localStorage.removeItem('x_public');
                    
                    if(response.data.status){
                        store.commit('auth/setAuthentication', null);
                        store.commit('user/setUser', null);
                        //localStorage.removeItem('tkn');
                        return res(response.data);
                    }
                    return rej(response.data);
                })
                .catch((response) => {
                    return rej(response);
                });
        } catch (error) {
            return rej(error);
        }

        
    });
};


